module.exports = __webpack_public_path__ + "img/fss-demo-main.abd8cb13.jpg";